import type { RefObject } from 'react';
import { globalListenerHelper, PRIORITY_NORMAL } from 'src/common/utils/global-listener-helper';

interface Listener {
  onMouseFocusInElement?: (container: RefObject<HTMLElement>) => void;
  onMouseHoverInElement?: (container: RefObject<HTMLElement>) => void;
}
/**
 * 监听鼠标是否在对应的element上
 */
export const monitorMouseFocusInElements = (
  listener: Listener,
  ...elementRef: RefObject<HTMLElement>[]
) => {
  const isInElement = (e: MouseEvent) => {
    for (const ref of elementRef) {
      if (!ref.current) continue;
      const rect = ref.current.getBoundingClientRect();
      if (e.clientX > rect.x && e.clientX < rect.x + rect.width) {
        return ref;
      }
    }
  };

  const pointer = (e: MouseEvent) => {
    const elementRef = isInElement(e);
    if (elementRef) {
      listener.onMouseFocusInElement?.(elementRef);
    }
  };

  const hover = (e: MouseEvent) => {
    const elementRef = isInElement(e);
    if (elementRef) {
      listener.onMouseHoverInElement?.(elementRef);
    }
  };

  /**
   * 这个方法主要是为了解决在rightPanel以外的地方使用useIsRight无效问题
   *
   * 这里主要是监听鼠标最后【focus到哪个panel，而不是鼠标move到哪个panel。】
   * 监听move事件导致的问题：在右侧panel选中块，按下方向键能选中下一个块，但如果鼠标移动到左侧再用方向键选取，就不行了（因为认为此时在左侧panel）。
   */
  if (listener.onMouseFocusInElement) {
    globalListenerHelper.addEventListener('pointerdown', pointer, PRIORITY_NORMAL, true);
    globalListenerHelper.addEventListener('pointerup', pointer, PRIORITY_NORMAL, true);
  }
  if (listener.onMouseHoverInElement) {
    globalListenerHelper.addEventListener('mousemove', hover, PRIORITY_NORMAL, true);
  }
  return () => {
    globalListenerHelper.removeEventListener('pointerdown', pointer, true);
    globalListenerHelper.removeEventListener('pointerup', pointer, true);
    globalListenerHelper.removeEventListener('mousemove', hover, true);
  };
};
